<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="accountManagerName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Gestor</th>
    <td mat-cell *matCellDef="let errors">
      {{ errors.accountManagerName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="accountManagerDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ Gestor</th>
    <td mat-cell *matCellDef="let element">
      {{ element.accountManagerDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.fundBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioB3Account">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta B3</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioB3Account }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="tradingDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data Pregão</th>
    <td mat-cell *matCellDef="let element">
      {{ element.tradingDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th mat-header-cell class="header" *matHeaderCellDef>Quantidade</th>
    <td mat-cell *matCellDef="let element">
      {{ element.amount | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="unitPrice">
    <th mat-header-cell class="header" *matHeaderCellDef>Preço Unitário</th>
    <td mat-cell *matCellDef="let element">
      {{ element.unitPrice | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="percentageDiscount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Percentual de Desconto
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.percentageDiscount | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="paperCode">
    <th mat-header-cell class="header" *matHeaderCellDef>Código Papel</th>
    <td mat-cell *matCellDef="let element">
      {{ element.paperCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="paperSerie">
    <th mat-header-cell class="header" *matHeaderCellDef>Série do Papel</th>
    <td mat-cell *matCellDef="let element">
      {{ element.paperSerie }}
    </td>
  </ng-container>

  <ng-container matColumnDef="broker">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Nome Corretora Contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.broker }}
    </td>
  </ng-container>

  <ng-container matColumnDef="brokerDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Documento Corretora Contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.brokerDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="brokerCode">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Código Corretora B3
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.brokerCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="brokerAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Conta Corretora Contraparte
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.brokerAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let element"
      [attr.colspan]="ColumnsFutures.length"
    >
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsFutures"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsFutures"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
